/* eslint semi:0 */
import { postId, } from 'application/pageDataObject'
import { TYPES as NAVBAR_ACTIONS, } from 'actions/navbarActions'
import { SOCIAL_BAR_ACTION_TYPES, } from './socialBarActionTypes'
import { getReactions, getShareButtons, getClientVotes, } from './socialBarDataSource'


function getSelectedReaction(){
  const votes = getClientVotes()
  if (postId in votes) {
    return votes[postId]
  }
  return null
}

function getDefaultState(){
  return {
    reactions: getReactions(),
    shareButtons: getShareButtons(),
    selectedReaction: getSelectedReaction(),
    isInCoverViewport: true,
    postId,
    reactionsComponentState: {},
  }
}

function getPercentage(numVotes, totalVotes){
  return parseInt(100 * numVotes / totalVotes, 10)
}

function getVoteAggregates(votes){
  const votesKeys = Object.keys(votes)
  const totalVotes = votesKeys.reduce(
    (acc, curr) => acc + votes[curr],
    0
  )
  const totalPercent = votesKeys.reduce(
    (acc, curr) => acc + getPercentage(votes[curr], totalVotes),
    0
  )
  const percentages = votesKeys.reduce(
    (acc, curr) => {
      acc[curr] = getPercentage(votes[curr], totalVotes)
      return acc
    },
    {}
  )
  return { votesKeys, totalVotes, totalPercent, percentages, }
}

function getVotesPercentages(votes){
  const { votesKeys, totalVotes, totalPercent, percentages, } = getVoteAggregates(votes)
  if (!totalVotes) {
    return {}
  }
  const gap = 100 - totalPercent
  if (!gap) {
    return percentages
  }
  const firstItemKey = votesKeys[0]
  const firstItemVal = percentages[firstItemKey] + gap
  const firstItemKVP = {
    [firstItemKey]: firstItemVal,
  }
  return { ...percentages, ...firstItemKVP, }
}

function incVotesWithSelfVote(votes, myReactionId){
  const votesWithMe = {
    [myReactionId]: (votes[myReactionId] || 0) + 1,
  }
  return { ...votes, ...votesWithMe, }
}

function filterVotesByReactions({ reactions, votes, }){
  const reactionIds = reactions.map(r => r.id)
  return Object
    .keys(votes)
    .filter(v => reactionIds.includes(v))
    .reduce(
      (acc, curr) => {
        acc[curr] = votes[curr]
        return acc
      },
      {}
    )
}

function reduceGetVotes(state, newState){
  const { votes = {}, } = newState
  const { reactions: reactionsData, } = state
  const { reactions, } = reactionsData
  const votesForCurrReactions = filterVotesByReactions({ reactions, votes, })
  const percentages = getVotesPercentages(votesForCurrReactions)
  return { ...state, ...newState, percentages, }
}

function reduceUserVote(state, newState){
  const { reactions: reactionsData, votes = {}, } = state
  const { reactions, } = reactionsData
  const { selectedReaction: myReactionId, } = newState
  const votesForCurrReactions = filterVotesByReactions({ reactions, votes, })
  const votesIncludingMine = incVotesWithSelfVote(votesForCurrReactions, myReactionId)
  const percentages = getVotesPercentages(votesIncludingMine)
  return { ...state, ...newState, percentages, }
}

function reduceComponentPosition(state, newState){
  const { isInViewport: isInCoverViewport, } = newState
  return { ...state, ...newState, isInCoverViewport, }
}

function getReactionsStateWithoutDeleted(state, reactionsComponentState){
  const { removePosition, } = reactionsComponentState
  const reactionsComponentStateWithoutDeleted = { ...reactionsComponentState, }
  delete reactionsComponentStateWithoutDeleted[removePosition]
  delete reactionsComponentStateWithoutDeleted.removePosition
  return {
    ...state,
    reactionsComponentState: reactionsComponentStateWithoutDeleted,
  }
}

function setReactionsComponentState(state, { reactionsComponentState, }){
  if (reactionsComponentState && reactionsComponentState.removePosition) {
    return getReactionsStateWithoutDeleted(state, reactionsComponentState)
  }
  return {
    ...state,
    reactionsComponentState: {
      ...state.reactionsComponentState,
      ...reactionsComponentState,
    },
  }
}

const { REACHED_COVER_SOCIAL_COMPONENT, } = NAVBAR_ACTIONS
const { REACTIONS, } = SOCIAL_BAR_ACTION_TYPES

export function socialBarReducer(state = getDefaultState(), action){
  switch (action.type) {
    case REACTIONS.SEND_VOTE:
      return reduceUserVote(state, action.state)
    case REACHED_COVER_SOCIAL_COMPONENT:
      return reduceComponentPosition(state, action.state)
    case REACTIONS.GET_VOTES:
      return reduceGetVotes(state, action.state)
    case REACTIONS.SET_REACTIONS_COMPONENT_STATE:
    case REACTIONS.DISPLAY:
    case REACTIONS.HIDE:
      return setReactionsComponentState(state, action.state)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/reactions/socialBarReducer.js